import styled from 'styled-components'
import { Flex, Button } from 'uikit'
import { useGetPredictionsStatus } from 'state/predictions/hooks'
import { PredictionStatus } from 'state/types'
import FlexRow from './FlexRow'
import { PricePairLabel, TimerLabel } from './Label'
import PrevNextNav from './PrevNextNav'
import HistoryButton from './HistoryButton'
import { Container } from '../Desktop'
import { useResponsive } from 'hooks/useResponse'

const SetCol = styled.div`
  flex: none;
  width: auto;

  ${({ theme }) => theme.mediaQueries.lg} {
    width: 270px;
    position: relative;
  }
`

const HelpButtonWrapper = styled.div`
  order: 1;
  margin: 0 2px 0 8px;

  ${({ theme }) => theme.mediaQueries.sm} {
    order: 2;
    margin: 0 0 0 8px;
  }
`

// const LeaderboardButtonWrapper = styled.div`
//   display: block;

//   order: 2;
//   margin: 0;

//   ${({ theme }) => theme.mediaQueries.sm} {
//     order: 3;
//     margin: 0 0 0 8px;
//   }
// `

const TimerLabelWrapper = styled.div`
  order: 3;
  width: 113px;

  ${({ theme }) => theme.mediaQueries.sm} {
    order: 1;
    width: auto;
  }
`

const ButtonWrapper = styled.div`
  display: none;

  ${({ theme }) => theme.mediaQueries.lg} {
    display: block;
    margin-left: 8px;
  }
`

const ImgIcon = styled.img`
  width: 20px;
  height: 20px;
`

const Menu = () => {
  const { isMobile } = useResponsive()
  const status = useGetPredictionsStatus()

  const btnStyle = isMobile
    ? { background: 'white', borderRadius: '12px', padding: '0', width: '48px', height: '56px', marginRight: '6px' }
    : { background: 'white', borderRadius: '40px', padding: '0', width: '40px', height: '40px' }

  return (
    <Container>
      <FlexRow alignItems="center" width="100%">
        <SetCol>
          <PricePairLabel />
        </SetCol>
        {status === PredictionStatus.LIVE && (
          <>
            <FlexRow justifyContent="center">
              <PrevNextNav />
            </FlexRow>
            <SetCol>
              <Flex alignItems="center" justifyContent="flex-end">
                <TimerLabelWrapper>
                  <TimerLabel interval="10" unit="m" />
                </TimerLabelWrapper>
                <HelpButtonWrapper>
                  <Button
                    variant="subtle"
                    as="a"
                    href="https://docs.mojitoswap.finance/products/prediction"
                    target="_blank"
                    rel="noreferrer noopener"
                    style={btnStyle}
                  >
                    <ImgIcon src={require('assets/images/prediction/warning.svg').default} />
                  </Button>
                </HelpButtonWrapper>
                {/* <LeaderboardButtonWrapper>
                  <Link to="/prediction/leaderboard">
                    <Button width="40px" style={btnStyle}>
                      <ImgIcon src={require('assets/images/prediction/cup2.svg').default} />
                    </Button>
                  </Link>
                </LeaderboardButtonWrapper> */}
                <ButtonWrapper style={{ order: 4 }}>
                  <HistoryButton />
                </ButtonWrapper>
              </Flex>
            </SetCol>
          </>
        )}
      </FlexRow>
    </Container>
  )
}

export default Menu
